module.exports = __webpack_public_path__ + "static/media/digidrive-mobile-screens.a2d61053.png";